import Form from "./components/Form";

export default Form;



// WEBPACK FOOTER //
// ./index.js